import {
  Box,
  Container,
  Heading,
  Image,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text
} from '@chakra-ui/react';
import React from 'react';
import TeacherPicture from '../TeacherPicture';
import estudiLogo from '../../resources/estudi.jpeg';

interface AdminSection {
  title: string;
  content: React.ReactNode;
}

/*
 * Each tab is a domain we are bringing over from Retool. Adding a new one is adding an entry
 * here plus its own component under src/components.
 */
const sections: AdminSection[] = [{ title: 'Profesores', content: <TeacherPicture /> }];

const Admin = () => (
  <React.Fragment>
    <Container maxW="container.lg">
      <Stack mb={5} mt={5}>
        <Image src={estudiLogo} alt="Estudi Logo" width="60px" alignSelf="center" />
      </Stack>
    </Container>
    <Container maxW="container.lg" pb={10}>
      <Stack spacing={1} mb={5}>
        <Heading size="lg">Backoffice</Heading>
        <Text fontSize="sm" color="gray.600">
          Herramientas internas de Estudi
        </Text>
      </Stack>
      <Tabs colorScheme="blue" isLazy>
        <TabList>
          {sections.map((section) => (
            <Tab key={section.title}>{section.title}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {sections.map((section) => (
            <TabPanel key={section.title} px={0}>
              <Box>{section.content}</Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Container>
  </React.Fragment>
);

export default Admin;
